<div class="container h-100">

    <div class="row justify-content-center align-content-center h-100 mob-padding">
        <div class="col-12 mb-4 mt-4">
            <h1 class="text-center text-light">{{"Searching for a specific type of data?" | translator}}</h1>
        </div>
        <div class="col-sm-6 col-12 mb-4" *ngFor="let item of items">
            <div class="card h-100 p-5 zoomIn">
                <h1>{{item.title}}</h1>
                <p>{{item.text}}</p>
                <p-button [label]="item.btn" styleClass="p-button-raised p-button-text"></p-button>
                <i class="pi pi-fw back-icon" [ngClass]="item.icon"></i>
            </div>
        </div>
    </div>
</div>